import uuid from 'uuid-random';
import { MAIN_CONTENT_SIZE } from '../../constants';
import { ActionTypes } from '../../contexts/textPresentationPageContext';
import { IState, IAction } from '../../contexts/textPresentationPageContext';
import { INote } from '../../types';

const LIMIT_DRAG_ELEMENTS = 20;

export const insertDraggableNote = (
  state: IState,
  dispatch: (action: IAction) => void,
  x: number,
  saveAddNoteUpdates: (prevState: INote[], state: INote[]) => void
): void => {
  if (state.notes.length < LIMIT_DRAG_ELEMENTS) {
    const newlyInsertedNote = {
      id: uuid(),
      isFocussed: true,
      isManuallyHidden: false,
      selectionStart: 0,
      content: '',
      position: {
        x: 50,
        y: getCoordinate(x),
      },
    };

    const payload = [...state.notes, newlyInsertedNote];

    saveAddNoteUpdates(state.notes, payload);

    dispatch({ type: ActionTypes.UPDATE_NOTE, payload });
  }
};

const getCoordinate = (x: number): number => {
  switch (x) {
    case MAIN_CONTENT_SIZE.M[0]:
    case MAIN_CONTENT_SIZE.L[0]:
      return 50;
    case MAIN_CONTENT_SIZE.S[0]:
      return 60;
    default:
      return 50;
  }
};
